// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  padding: 80px 0;
}

.left {
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.main {
  font-family: sans-serif;
  font-size: 2.5rem;
  line-height: 46px;
  letter-spacing: 0;
  font-weight: 700;
}
.card {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  transition: transform 0.3s ease;
  &:hover {
      transform: translateY(-5px) translateX(-5px) translateZ(-20px);
      /* Adjust the elevation (negative value) as needed */
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      /* Adjust the box shadow for raised effect */
    }
}
.card:hover {
  background-color: #ffcc00;
  /* Change this to the desired shade of yellow/orange */
}

.card h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 10px;
}

.card p {
  color: #555;
  font-size: 16px;
  line-height: 1.6;
}
.icon {
  font-size: 24px;
  color: #e30613;
}
.first-main-con {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}
  

@keyframes slideFromLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.card h2,
.card p {
  opacity: 0;
  animation: slideFromLeft 1s ease forwards;
}

.card p {
  animation-delay: 0.5s;
}

.card:nth-of-type(2) h2,
.card:nth-of-type(2) p {
  animation: slideFromRight 1s ease forwards;
}

.card:nth-of-type(2) p {
  animation-delay: 0.5s;
}






/* .card:nth-of-type(2) h2,
.card:nth-of-type(2) p {
  animation: slideFromRight 1s ease forwards;
}

.card:nth-of-type(2) p {
  animation-delay: 0.5s;
} */

@media screen and (max-width: 1000px) {
  .container {
    flex-direction: column;
  }

  .left {
    width: 100%;
    margin-top: 30px;
  }

  .right {
    width: 100%;
    align-items: center;
  }

  .main {
    text-align: center;
    padding: 0 20px;
  }
  .first-main-con{
    grid-template-columns: repeat(1,1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/Home/First.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,sCAAsC;EACtC,+BAA+B;EAC/B;MACI,8DAA8D;MAC9D,oDAAoD;MACpD,wCAAwC;MACxC,4CAA4C;IAC9C;AACJ;AACA;EACE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;;AAGA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;;;;;;AAOA;;;;;;;GAOG;;AAEH;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9f9f9;\n  padding: 80px 0;\n}\n\n.left {\n  width: 40%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.right {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.main {\n  font-family: sans-serif;\n  font-size: 2.5rem;\n  line-height: 46px;\n  letter-spacing: 0;\n  font-weight: 700;\n}\n.card {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n  transition: transform 0.3s ease;\n  &:hover {\n      transform: translateY(-5px) translateX(-5px) translateZ(-20px);\n      /* Adjust the elevation (negative value) as needed */\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n      /* Adjust the box shadow for raised effect */\n    }\n}\n.card:hover {\n  background-color: #ffcc00;\n  /* Change this to the desired shade of yellow/orange */\n}\n\n.card h2 {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.card p {\n  color: #555;\n  font-size: 16px;\n  line-height: 1.6;\n}\n.icon {\n  font-size: 24px;\n  color: #e30613;\n}\n.first-main-con {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 20px;\n}\n  \n\n@keyframes slideFromLeft {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideFromRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.card h2,\n.card p {\n  opacity: 0;\n  animation: slideFromLeft 1s ease forwards;\n}\n\n.card p {\n  animation-delay: 0.5s;\n}\n\n.card:nth-of-type(2) h2,\n.card:nth-of-type(2) p {\n  animation: slideFromRight 1s ease forwards;\n}\n\n.card:nth-of-type(2) p {\n  animation-delay: 0.5s;\n}\n\n\n\n\n\n\n/* .card:nth-of-type(2) h2,\n.card:nth-of-type(2) p {\n  animation: slideFromRight 1s ease forwards;\n}\n\n.card:nth-of-type(2) p {\n  animation-delay: 0.5s;\n} */\n\n@media screen and (max-width: 1000px) {\n  .container {\n    flex-direction: column;\n  }\n\n  .left {\n    width: 100%;\n    margin-top: 30px;\n  }\n\n  .right {\n    width: 100%;\n    align-items: center;\n  }\n\n  .main {\n    text-align: center;\n    padding: 0 20px;\n  }\n  .first-main-con{\n    grid-template-columns: repeat(1,1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
